import React from 'react';
import { useSelector } from 'react-redux';
import {Layout, Card} from 'antd';
import StockChart from '../../charts/StockChart';



const TimeseriesBlender = () => {

    const dataSeries = []
    const blendedSeries = useSelector(state => state.timeSeries.blendedSeries);

    if (!blendedSeries) {
        return null;
    }
    blendedSeries.forEach(x=>{
        dataSeries.push({
            name: x?.name,
            type: 'line',
            data: x.data,
            stroke: '#105DEB',
            strokeWidth: 2,
            hasSnapshot: true
        })
    })
    console.log(blendedSeries);

    return (
        <Layout>
            <Layout.Content>
                <Card
                    title={'Blended Timeseries'}
                    bordered={false}
                >
                    <StockChart
                        height={650}
                        dataSeries={[
                            {
                                plot: 0,
                                data: dataSeries,
                                yScale: 'percent',
                                yLabelPostfix: '%',
                                legend: {
                                    format: "%",
                                    precision: 2
                                }
                            }
                        ]}
                    />
                </Card>
            </Layout.Content>
        </Layout>
    );
};

export default TimeseriesBlender;
